import { VIDEO_CALL } from 'constants/identityMethod';

export const getClauseByVideo = ({ videoSelected, biometryDecisionActive, isSelectedVideoselfieWithBiometrics }) => {
    if (videoSelected === VIDEO_CALL) {
        return 'identity-gdprVideoCallClause';
    }
    if (isSelectedVideoselfieWithBiometrics) {
        return biometryDecisionActive ? 'identity-videoselfieClauseWithBiometrics' : 'identity-gdprVideoSelfieClause';
    }

    return 'identity-videoselfieClauseWithouthBiometrics';
};
